<div class="components-frame">
  <div class="content">
    @switch (component) {
      @case ('video') {
        <andor-video [mode]="mode"></andor-video>
      }
      @case ('chat') {
        <andor-chat [mode]="mode"></andor-chat>
      }
      @case ('whiteboard') {
        <andor-whiteboard></andor-whiteboard>
      }
      @case ('spatial') {
        <andor-spatial></andor-spatial>
      }
    }
  </div>

  @if ((appService.activeBreakpoint$ | async) !== 'small') {
    <div class="pin {{ mode === 'pinned' ? 'pinned' : 'main' }}">
      @if (mode === 'pinned') {
        <button (click)="switchComponents()" [style.--swap-rotation.deg]="swapRotationDeg()">
          <fa-icon [icon]="faArrowUpArrowDown"></fa-icon>
        </button>
      }
    </div>
  }
</div>
